import GainScoreBarChart from './GainScoreBarChart';

export default GainScoreBarChart;
